<template>
    <p-modal v-if="display" @onClickBG="onCancel">
        <div slot="content">
            <div class="title">
                進階需求
            </div>
        </div>
        <div slot="list" class="list">
            <div class="item">
                <div class="checkbox">
                    <label for="insulation">需要保溫</label>
                    <input type="checkbox" id="insulation" v-model="insulation">
                </div>
            </div>
            <div class="item">
                <div class="checkbox">
                    <label for="ordered">我跟店家訂好了</label>
                    <input type="checkbox" id="ordered" v-model="ordered">
                </div>
                <div class="sub-item" v-show="ordered">
                    <input type="text" v-model="orderedName" placeholder="訂購姓名" @change="unclickPrincipal">
                    <input type="text" v-model="orderedPhone" placeholder="訂購電話" @change="unclickPrincipal">
                    <div class="principal" :class="{green: isPrincipal}" v-if="user.name">
                        <input type="checkbox" id="principal" v-model="isPrincipal" @change.stop="clickPrincipal" ref="principal" hidden>
                        <label for="principal">
                            <img v-show="isPrincipal" src="@/assets/img/check.svg">
                            <img v-show="!isPrincipal" src="@/assets/img/check-none.svg">
                            訂購資訊同委託人
                        </label>
                    </div>
                </div>
            </div>
            <div class="item">
                <label for="vat">購買商品需打統編</label>
                <input type="text" id="vat" v-model="vat" placeholder="僅限此店家購買商品">
            </div>
        </div>
        <div slot="buttons" class="buttons">
            <div class="cancel button" @click.stop="onClear">
                清除全部
            </div>
            <div class="confirm button" @click.stop="onConfirm">
                儲存
            </div>
        </div>
    </p-modal>
</template>

<script>
    import Modal from './Modal';
    import { mapGetters } from 'vuex';

    export default {
        name: 'ShopAdvancedModal',
        components: {
            'p-modal': Modal,
        },
        data() {
            return {
                display: false,
                ordered: false,
                orderedName: '',
                orderedPhone: '',
                insulation: false,
                vat: '',
                isPrincipal: false,
            };
        },
        computed: {
           ...mapGetters(['user'])
        },
        methods: {
            onConfirm() {
                this.$emit('onConfirm', {
                    'ordered': this.ordered,
                    'orderedName': this.ordered ? this.orderedName : '',
                    'orderedPhone': this.ordered ? this.orderedPhone : '',
                    'insulation': this.insulation,
                    'vat': this.vat
                });
                this.unclickPrincipal();
                this.display = false;
            },
            onCancel() {
                this.unclickPrincipal();
                this.display = false;
                this.$emit('onCancel');
            },
            onClear() {
                this.$emit('onConfirm', {
                    'ordered': false,
                    'orderedName': '',
                    'orderedPhone': '',
                    'insulation': false,
                    'vat': '',
                });
                this.unclickPrincipal();
                this.display = false;
            },
            show(ordered, insulation, vat, orderedName, orderedPhone) {
                this.ordered = ordered;
                if (!orderedName && !orderedPhone) {
                    this.orderedName = this.user.name;
                    this.orderedPhone = this.user.phone;
                    this.isPrincipal = true;
                } else {
                    this.orderedName = orderedName;
                    this.orderedPhone = orderedPhone;
                    this.isPrincipal = false;
                }

                this.insulation = insulation;
                this.vat = vat;
                this.display = true;
            },
            unclickPrincipal() {
                if (this.isPrincipal && this.$refs.principal) {
                    this.$refs.principal.click();
                }
            },
            clickPrincipal() {
                if (this.isPrincipal) {
                    this.orderedName = this.user.name;
                    this.orderedPhone = this.user.phone;
                }
            },
        }
    };
</script>

<style lang="scss" scoped>
    .title {
        color: rgba(0,0,0,1);
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        text-align: center;
    }

    .list {
        margin-bottom: 20px;
        .item {
            padding: 14px 25px;
            border-bottom: 1px solid #ddd;
            user-select: none;
            cursor: pointer;
            text-align: left;

            &:last-child{
                border-bottom: none;
            }

            input[type=text] {
                margin-top: 13px;
                width: 100%;
                padding: 6px 15px;
                box-sizing: border-box;
                border: 1px solid #bbbbbb;
                border-radius: 5px;
            }

            label {
                color: #4A4A4A;
                font-size: 16px;
                letter-spacing: 0;
                line-height: 22px;
                flex: 1;
                text-align: left;
            }

            .principal {
                position: relative;
                margin-top: 10px;

                label {
                    display: flex;
                }

                &.green {
                    label {
                        color: #339933;
                    }
                }

            }

            .checkbox {
                display: flex;
                justify-content: space-between;
                position: relative;

                input[type=checkbox]:before {
                    content: '';
                    top: 0;
                    right: 0;
                    width: 22px;
                    height: 22px;
                    border: 1px solid #bbbbbb;
                    border-radius: 50%;
                    position: absolute;
                    background-color: #ffffff;
                }

                input[type=checkbox]:after {
                    content: '';
                    top: 5px;
                    right: 13px;
                    width: 6px;
                    height: 10px;
                    position: absolute;
                    border-bottom: 2px solid #bbbbbb;
                    border-right: 2px solid #bbbbbb;
                    transform: rotate(45deg);
                    transform-origin: 100% 100%;
                }

                input[type=checkbox]:checked:before {
                    content: '';
                    top: 0;
                    right: 0;
                    width: 22px;
                    height: 22px;
                    border: 1px solid #bbbbbb;
                    border-radius: 50%;
                    position: absolute;
                    background-color: #36B736;
                }

                input[type=checkbox]:checked:after {
                    content: '';
                    top: 5px;
                    right: 13px;
                    width: 6px;
                    height: 10px;
                    position: absolute;
                    border-bottom: 2px solid #fff;
                    border-right: 2px solid #fff;
                    transform: rotate(45deg);
                    transform-origin: 100% 100%;
                }
            }
        }
    }

    .subtitle {
        color: rgba(120,120,120,1);
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        margin-top: 5px;

        span {
            &.red {
                color: #F44336;
                font-weight: 500;
            }
        }
    }

    .buttons {
        display: flex;

        .button {
            width: calc(50% - 1px);
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            padding: 12px 0;
            cursor: pointer;
            user-select: none;

            &.cancel {
                color: rgba(155,155,155,1);
            }

            &.confirm {
                color: #339933;
            }

            &:first-child {
                border-right: solid 1px rgba(221,221,221,1);
            }
        }
    }
</style>
